import { render, staticRenderFns } from "./m25.vue?vue&type=template&id=97601680&scoped=true"
import script from "./m25.vue?vue&type=script&lang=js"
export * from "./m25.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97601680",
  null
  
)

export default component.exports